import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Sparkles, LogOut } from "lucide-react";

const DemoBanner = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (!user || user.company !== "demo") return null;

  const exitDemo = () => {
    logout();
    navigate("/", { replace: true });
  };

  return (
    <div
      data-testid="demo-banner"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[9998] flex items-center gap-3 rounded-full bg-[#ff7e00] text-white shadow-lg shadow-black/20 pl-4 pr-2 py-2 max-w-[94vw]"
    >
      <Sparkles size={17} className="shrink-0" />
      <span className="text-[13px] font-bold whitespace-nowrap">
        Modalità Demo
      </span>
      <span className="hidden sm:inline text-[12px] text-white/90 whitespace-nowrap">
        · dati fittizi, si azzerano a ogni avvio
      </span>
      <button
        onClick={exitDemo}
        data-testid="demo-banner-exit"
        className="ml-1 inline-flex items-center gap-1.5 rounded-full bg-white/20 hover:bg-white/30 transition-colors text-[12px] font-bold px-3 py-1.5"
      >
        <LogOut size={14} /> Esci
      </button>
    </div>
  );
};

export default DemoBanner;
